<template>
  <div style="position: relative;">
    <div
      v-if="conversationList.length > 1"
      style="position: absolute; top: -35px;  left: 75px; z-index: 1; display: flex; align-items: center;"
    >
      {{ conversationList.length }} conversations
    </div>

    <div
      v-if="initialData.technicianMode"
      style="position: absolute; top: -40px; right: 0; z-index: 1; display: flex; align-items: center; gap: 8px;"
    >
      <span>Filter:</span>
      <v-checkbox
        v-model="filterAutoNotifications"
        color="success"
        label="Auto Notifications"
        hide-details
        class="mt-0 pt-0"
        style="flex-shrink: 0;"
        small
        @change="
          setAutoNotificationFilter();
          expandConversation(0);
        "
      ></v-checkbox>
    </div>

    <div
      v-if="!initialData.oldTicket"
      style="position: absolute; top: -25px; right: 0; z-index: 1; display: flex; align-items: center; gap: 8px;"
    >
      <p style="margin: 0; font-size: 12px; color: grey;">
        New conversations may take a moment to appear. Click refresh to update.
      </p>
      <v-btn
        v-if="conversationList"
        icon
        flat
        small
        :disabled="loading"
        @click="updateConversationListAndNoteList()"
        title="Refresh Conversations"
        hint="Refresh Conversations"
      >
        <v-progress-circular
          v-if="loading"
          indeterminate
          size="18"
          width="2"
          color="grey"
        />
        <v-icon v-else color="grey">mdi-refresh</v-icon>
      </v-btn>

      <v-btn
        v-if="conversationList.length > 1"
        icon
        flat
        small
        @click="
          conversationList.some((c) => !c.expand)
            ? expandAllConversations()
            : conversationList.map((c) => (c.expand = false))
        "
        :title="
          conversationList.some((c) => !c.expand)
            ? `Expand All ${conversationList.length} Conversations`
            : `Collapse All ${conversationList.length} Conversations`
        "
      >
        <v-icon color="grey">{{
          conversationList.some((c) => !c.expand)
            ? "mdi-arrow-expand-vertical"
            : "mdi-arrow-collapse-vertical"
        }}</v-icon>
      </v-btn>

      <v-btn
        v-if="conversationList"
        icon
        flat
        small
        @click="toggleSortOrder"
        :title="descSortOrder == 'desc' ? 'Ascending' : 'Descending'"
      >
        <v-icon color="grey">{{
          descSortOrder == "desc" ? "mdi-sort-descending" : "mdi-sort-ascending"
        }}</v-icon>
      </v-btn>
    </div>
    <v-timeline dense v-if="conversationList" class="no-line mt-5">
      <v-timeline-item
        v-for="(conversation, index) in conversationList"
        :key="index"
        :color="conversationBgColor(conversation.type)"
        fill-dot
        style="margin-bottom: -12px;"
      >
        <v-icon slot="icon" small>{{
          conversationIcon(conversation.type)
        }}</v-icon>
        <v-card
          :color="conversationBgColor(conversation.type)"
          :style="
            `border-radius:5px; border: 4px solid ${conversationBgColor(
              conversation.type
            )};`
          "
          class="elevation-0"
        >
          <v-card-title
            class="py-1 px-3"
            style="cursor: pointer; display: flex; align-items: center;"
            @click="expandConversation(index)"
          >
            <span>
              <span style="font-weight: 500;">{{
                conversation.senderName != "UserPortal"
                  ? conversation.senderName
                  : regex.test(conversation.description)
                  ? regex.exec(conversation.description)[1]
                  : ""
              }}</span>
              <template
                v-if="
                  conversation.senderName != 'UserPortal' ||
                    regex.test(conversation.description)
                "
              >
                -
              </template>
              {{ conversation.timeDisplayValue }}
              <span v-if="conversation.hasAttachments">
                &nbsp;<v-icon small>mdi-attachment</v-icon>
              </span>
            </span>
            <span style="margin-left: auto;" v-show="conversation.load">
              <v-progress-circular
                indeterminate
                size="16"
                width="2"
              ></v-progress-circular>
            </span>
            <v-icon
              small
              style="margin-left: auto;"
              v-show="!conversation.expand && !conversation.load"
            >
              mdi-chevron-down
            </v-icon>
            <v-icon
              small
              style="margin-left: auto;"
              v-show="conversation.expand && !conversation.load"
            >
              mdi-chevron-up
            </v-icon>
          </v-card-title>

          <v-card-text
            v-show="conversation.expand"
            class="white pt-3"
            style="border-radius:5px;"
          >
            <h6
              v-if="conversation.subject"
              class="font-weight-bold"
              v-html="conversation.subject"
            ></h6>
            <p class="mt-0" v-if="conversation.sendTo">
              <b>To:</b> {{ getSendCTo(conversation.sendTo) }}
            </p>
            <v-divider
              v-if="
                conversation.description &&
                  (conversation.sendTo || conversation.subject)
              "
            ></v-divider>
            <div
              class="ma-0 pa-0"
              style="overflow-wrap: break-word; word-break: break-word; overflow: hidden;"
              v-if="conversation.description"
              v-html="conversation.description"
            ></div>
            <div v-if="conversation.attachments">

              <div class="font-weight-medium mt-3 mb-1" style="color: gray;">
                <!-- <v-icon color="gray" small>mdi-attachment</v-icon> -->
                {{ getAttachmentCountText(conversation.attachments) }}
              </div>
              <div style="display: flex; flex-wrap: wrap; gap: 4px;">
                <div
                  v-for="attachment in getAttachments(conversation.attachments)"
                  :key="attachment.name"
                  style="display: contents;"
                >
                  <div
                    v-if="!isAudioFile(attachment.name)"
                    class="audio-attachment-row-conversation"
                    style="cursor: pointer;"
                    @click="loadFile(attachment)"
                  >
                    <v-icon color="blue" small>mdi-file</v-icon>
                    <span style="flex: 1; font-size: 13px;">{{
                      truncateText(attachment.name)
                    }}</span>
                    <v-icon small color="blue">mdi-open-in-new</v-icon>
                  </div>

                  <div v-else class="audio-attachment-row-conversation" style="width: 315px;">
                    <audio controls style="height: 18px;">
                      <source
                        :src="getAudioSrc(attachment)"
                        type="audio/mpeg"
                      />
                    </audio>
                    <v-icon small @click="loadFile(attachment)" color="blue"
                      >mdi-open-in-new</v-icon
                    >
                  </div>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>
<script>
import { truncate } from "../../utils/helpers.js";
import {
  loadFile,
  isAudioFile,
  getAudioSrc,
  getAttachmentCountText,
} from "./helpDeskHelpers.js";
export default {
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    initialData(newVal) {
      if (newVal.ticket.id !== this.request.id) {
        this.request = newVal.ticket;
        this.initConversationList();
        this.filterAutoNotifications = false;
        // if (
        //   this.request.notificationStatus != null ||
        //   (this.initialData.technicianMode == true &&
        //     this.request.hasNotes == true)
        // ) {
        //   this.getConversations();
        // }
      }
    },
  },
  async created() {
    this.request = this.initialData.ticket;
    await this.initConversationList();
    //  this.updateConversationListAndNoteList();
    // if (
    //   this.request.notificationStatus != null ||
    //   (this.initialData.technicianMode == true && this.request.hasNotes == true)
    // ) {
    //   this.getConversations();
    // }
  },
  data: () => ({
    request: null,
    loadingConversations: false,
    conversationList: null,
    conversationListOriginal: null,
    conversationAttachments: null,
    loading: false,
    filterAutoNotifications: false,
    descSortOrder:
      localStorage.getItem("helpDeskConversationsDescSortOrder") || "desc",
    regex: /<b>From:\s*<\/b>\s*([\s\S]*?)\s*<hr/i,
  }),
  methods: {
    initConversationList() {
      this.conversationList = [
        {
          senderName: this.request.requesterName,
          timeDisplayValue: this.request.createdTimeDisplayValue,
          description: this.request.description,
          type: "DESCRIPTION",
          expand: true,
          expanded: true,
          sendTo: this.request.emailTo,
          load: false,
          hasAttachments: false,
        },
      ];
      if (!this.initialData.oldTicket) {
        this.getConversations();
      }
    },

    async getConversations() {
      this.loadingConversations = true;
      this.loading = true;
      const conversations = await this.$http.get(
        `api/manageengine/GetConversationsByTicket?manageengineID=${
          this.request.manageengineID
        }&requestID=${this.request.id}&technicianMode=${
          this.initialData.technicianMode
        }`
      );
      this.loading = false;
      this.loadingConversations = false;

      //const regex = /<b>From:\s*<\/b>\s*([\s\S]*?)\s*<hr/i;

      const mapped = conversations.map((c) => ({
        ...c,
        // senderName:
        //   c.senderName != "UserPortal"
        //     ? c.senderName
        //     : regex.test(c.description)
        //     ? regex.exec(c.description)[1]
        //     : "",
        expand: false,
        expanded: false,
        load: false,
      }));
      const descriptionItem = this.conversationList.find(
        (c) => c.type === "DESCRIPTION"
      );
      this.conversationList = descriptionItem
        ? [...mapped, descriptionItem]
        : mapped;

      this.conversationListOriginal = this.conversationList;
      this.setAutoNotificationFilter();

      if (this.descSortOrder == "asc") {
        this.conversationList.reverse();
      } else if (
        this.descSortOrder == "desc" &&
        this.conversationList.length > 1
      ) {
        this.expandConversation(0);
      }
    },

    async expandConversation(i) {
      if (this.conversationList[i].expand) {
        this.conversationList[i].expand = false;
        this.$set(this.conversationList, i, this.conversationList[i]);
      } else if (this.conversationList[i].expanded) {
        this.conversationList[i].expand = true;
        this.$set(this.conversationList, i, this.conversationList[i]);
      } else {
        this.conversationList[i].load = true;
        if (
          this.conversationList[i].type == "NOTES" &&
          this.conversationList[i].isUpdatedByMA
        ) {
          try {
            const response = await this.$http.get(
              `api/manageengine/GetNote?manageengineID=${
                this.conversationList[i].manageengineRequestID
              }&noteID=${this.conversationList[i].conversationID}`
            );
            this.$set(this.conversationList, i, response);
          } catch {}
        } else if (
          this.conversationList[i].type != "NOTES" &&
          this.conversationList[i].sendTo == null
        ) {
          try {
            const response = await this.$http.get(
              `api/manageengine/GetConversation?manageengineID=${
                this.conversationList[i].manageengineRequestID
              }&conversationID=${this.conversationList[i].conversationID}`
            );
            this.$set(this.conversationList, i, response);
          } catch {}
        }
        this.conversationList[i].load = false;
        this.conversationList[i].expanded = true;
        this.conversationList[i].expand = true;
      }
    },

    conversationIcon(type) {
      return type === "REQREPLY"
        ? "mdi-email"
        : type === "NOTES"
        ? "mdi-note-text"
        : type === "DESCRIPTION"
        ? "mdi-file-document"
        : "mdi-message";
    },
    conversationBgColor(type) {
      return type === "REQREPLY"
        ? "#d9ffeb"
        : type === "NOTES"
        ? "#fff2d1"
        : type === "DESCRIPTION"
        ? "#f3f1f9"
        : type === "REQFORWARD"
        ? "#ddf7ff"
        : type === "CONVERSATION"
        ? "#ffe5e5"
        : "#d9ffeb";
    },
    getSendCTo(l) {
      try {
        return JSON.parse(l).join(", ");
      } catch {
        return l;
      }
    },
    getAttachmentCountText(attachments) {
      return getAttachmentCountText(JSON.parse(attachments));
    },
    getAttachments(attachments) {
      return JSON.parse(attachments);
    },
    isAudioFile(fileName) {
      return isAudioFile(fileName);
    },
    loadFile(file) {
      loadFile(file);
    },

    getAudioSrc(file) {
      return getAudioSrc(file);
    },
    truncateText(attachment) {
      return truncate(attachment, 20);
    },

    toggleSortOrder() {
      this.descSortOrder = this.descSortOrder == "desc" ? "asc" : "desc";
      localStorage.setItem(
        "helpDeskConversationsDescSortOrder",
        this.descSortOrder
      );
      this.conversationList.map((c) => (c.expand = false));
      this.conversationList.reverse();
      this.expandConversation(0);
    },

    async updateConversationListAndNoteList() {
      this.loading = true;
      try {
        await this.$http.post(
          `api/manageengine/updateConversationListAndNoteList?manageengineID=${
            this.request.manageengineID
          }&requestID=${this.request.id}`
        );
      } catch {
        this.loading = false;
      } finally {
        this.getConversations();
        this.loading = false;
      }
    },
    setAutoNotificationFilter() {
      if (!this.filterAutoNotifications) {
        this.conversationList = this.conversationListOriginal.filter(
          (c) =>
            c.type == "DESCRIPTION" ||
            c.type == "CONVERSATION" ||
            c.type == "REQREPLY" ||
            c.type == "REQFORWARD" ||
            c.type == "NOTES"
        );
      } else {
        this.conversationList = this.conversationListOriginal;
      }
    },
    async expandAllConversations() {
      for (let i = 0; i < this.conversationList.length; i++) {
        await this.expandConversation(i);
        this.conversationList[i].expand = true;
        this.$set(this.conversationList, i, this.conversationList[i]);
      }
    },
  },
};
</script>
<style>
.no-line.v-timeline:before {
  display: none !important;
}

.audio-attachment-row-conversation {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 4px 8px;
  border: 1px solid #e0e0e0;
  margin-right: 20px;
  margin-bottom: 10px;
}
</style>
